/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-27",
    versionChannel: "nightly",
    buildDate: "2023-06-27T00:23:09.281Z",
    commitHash: "96e3d36a6ef22d233bed431dd23868d756b095c4",
};
